import controller from './user-home-controller';
import template from './user-home.html';

const UserHomeComponent = {
    bindings: {},
    controller,
    template,
};

export default UserHomeComponent;



// WEBPACK FOOTER //
// ./app/components/home/user-home/user-home-component.js